import React from 'react';
import { Tag } from 'antd';
import { CHROMATIC_PALETTES } from '../theme/index.js';

type Palette = (typeof CHROMATIC_PALETTES)[keyof typeof CHROMATIC_PALETTES];

interface Props {
  article: string;
  palette: Palette;
  size?: 'small' | 'large';
}

/**
 * The article (der / die / das) in its gender colour: blue = masculine, red = feminine, green =
 * neuter. The colour dot is drawn with CSS rather than an emoji, so it renders the same on every
 * system and never overlaps the text.
 */
export const GenderBadge: React.FC<Props> = ({ article, palette, size = 'small' }) => {
  const large = size === 'large';
  return (
    <Tag
      style={{
        margin: 0,
        display: 'inline-flex',
        alignItems: 'center',
        gap: large ? 8 : 6,
        fontSize: large ? 16 : 13,
        padding: large ? '4px 16px' : '1px 10px',
        borderRadius: 20,
        color: palette.color,
        backgroundColor: palette.bg,
        borderColor: palette.border,
        fontWeight: 700,
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: large ? 10 : 8,
          height: large ? 10 : 8,
          borderRadius: '50%',
          backgroundColor: palette.color,
          flexShrink: 0,
        }}
      />
      {article}
    </Tag>
  );
};
